import ApplicationController from '../application_controller'
import { enableElements, disableElements } from '../../lib/elements_helper'

class AuthenticatorsController extends ApplicationController {
  static targets = ['radiobutton', 'checkbox']

  connect () {
    this.radiobuttonTargets.forEach(elm => {
      elm.addEventListener('click', (e) => { this.handleSelector(e.target) })
    })

    this.checkboxTargets.forEach(elm => {
      elm.addEventListener('change', () => {
        document.getElementById('two_fa_settings_1').checked = true
      })
    })
  }

  handleSelector (target) {
    if (target.value === '0') {
      this.checkboxTargets.forEach(elm => {
        elm.checked = false
        elm.setAttribute('disabled', true)
      })
    } else {
      enableElements(...this.checkboxTargets)
    }
  }
}

export default AuthenticatorsController
